import React from 'react';
import { Link } from 'react-router-dom';
import { template, templateSettings } from 'lodash';
import { TrackingCtx, trackEvent, combineEvent  } from "../tracking";

const trackClick = (tracking, to) => () => {
    try {
      if (!tracking) return;
      trackEvent(combineEvent({
        action: 'Link Click',
        label: to
      }, tracking))
    } catch(e) {
      // console.log('Error tracking click', e);
    }
}

export const Redirect = ({ to, value, className, tooltip }) => {
  const hasProtocol = link => link.startsWith('http');
  return (
    <TrackingCtx.Consumer>
    {tracking => (
      <>
      { hasProtocol(to) && (
        <a
          href={to}
          target="_blank"
          className={className}
          rel="noopener noreferrer"
          title={tooltip}
          onClick={trackClick(tracking, to)}
        >
          {value}
        </a>
      )}
      { !hasProtocol(to) && (
        <Link
          to={to}
          className={className}
          onClick={trackClick(tracking, to)}
        >{value}</Link>
      )}
      </>
    )}
    </TrackingCtx.Consumer>
  );
};

// values here is a placement or an order or (now) a package
export const composeLink = (string, values) => {
  try {
    templateSettings.interpolate = /{([\s\S]+?)}/g;
    const compiled = template(string);
    return compiled(values);
  } catch(e) {
    return false;
  }
};

const GAM_PRIMARY = `https://admanager.google.com/36117602`;

export const GLO_ORDER = '/ios/{id}';
export const GLO_ADVERTISER = '/advertiser/{id}';
export const GLO_PLACEMENT = '/ios/{IoId}/placement/{id}';
export const GLO_PACKAGE = '/ios/{IoId}/package/{id}';
export const GLO_PL_FROM_PKG = '/ios/{IoId}/placement/{pid}';

export const GAM_ORDER_PRIMARY = `${GAM_PRIMARY}?pli=1#delivery/order/order_overview/order_id={dfpOrderId}`;
export const GAM_LINE_PRIMARY = `${GAM_PRIMARY}#delivery/line_item/detail/line_item_id={dfpLineItemId}`;
export const GAM_PROPOSAL_PRIMARY = `${GAM_PRIMARY}#delivery/proposal/overview/proposal_id={dfpProposalId}`;
export const GAM_PLI_PRIMARY = `${GAM_PRIMARY}#delivery/proposal_line_item/detail/proposal_line_item_id={dfpProposalLineItemId}`;
